"use client";

import React, { useRef } from "react";
import FlexBox from "../../../FlexBox/FlexBox";
import { lePetitPrinceImages } from "../../../../Assets/images/le-petit-prince";
import Typography from "../../../../Foundation/Typography/Typography";
import { _HeaderPetitPrinceRoot } from "./HeaderPetitPrince.styled";
import StyledDiv from "../../../StyledDiv/StyledDiv";
import HeaderPetitPrinceDecorationBase from "./HeaderPetitPrinceDecorationBase/HeaderPetitPrinceDecorationBase";
import htmlParse from "html-react-parser";
import { rem } from "../../../../Utils/font";
import FadeIn from "../../../Animations/FadeIn";

interface IHeaderPetitPrinceProps {
  title?: string;
  /** Activer l'animation de parallax au scroll pour les décorations */
  enableScrollAnimation?: boolean;
}

const HeaderPetitPrince = ({
  title,
  enableScrollAnimation = true,
}: IHeaderPetitPrinceProps) => {
  const headerRef = useRef<HTMLDivElement>(null);

  return (
    <_HeaderPetitPrinceRoot ref={headerRef} className="header-petit-prince">
      <StyledDiv
        styles={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          zIndex: 0,
        }}
      >
        <HeaderPetitPrinceDecorationBase
          triggerRef={headerRef}
          enableScrollAnimation={enableScrollAnimation}
          styles={{
            position: "fixed",
            top: 0,
            // left: 0,
            width: "100%",
            height: "100%",
            pointerEvents: "none",
            zIndex: 0,
            paddingTop: 64,
            mobile: {
              position: "absolute",
              paddingTop: 0,
              height: "124%",
            },
          }}
        />
      </StyledDiv>

      <StyledDiv
        as={FlexBox}
        direction="column"
        align="center"
        justify="center"
        gap={35}
        styles={{
          maxWidth: 546,
          position: "relative",
          zIndex: 2,
          mobile: {
            maxWidth: 290,
            gap: 16,
          },
        }}
      >
        <FadeIn delay={0.1}>
          <StyledDiv
            as="img"
            src={lePetitPrinceImages.logoSushiPetitPrince}
            alt="Logo Petit Prince"
            styles={{
              lineHeight: "124%",
              width: "100%",
              maxWidth: 280,
              mobile: {
                maxWidth: 148,
              },
            }}
          />
        </FadeIn>
        <FadeIn delay={0.2}>
          <StyledDiv
            as={Typography}
            variant="subtitle2"
            color="white"
            align="center"
            styles={{
              mobile: {
                fontSize: rem(15),
                fontStyle: "normal",
                fontWeight: 400,
                lineHeight: "140%",
                letterSpacing: "-0.15px",
              },
            }}
          >
            {htmlParse(title || "") || ""}
          </StyledDiv>
        </FadeIn>
      </StyledDiv>
    </_HeaderPetitPrinceRoot>
  );
};

export default React.memo(HeaderPetitPrince);
